import React from "react";
import { Paper, Typography, Divider, Stack } from "@mui/material";
import { formatItemFragment } from "../../utils/formatItems";

function renderItems(items) {
  // tolerate both array-of-objects (preferred) and string fallback
  if (Array.isArray(items)) {
    return items.map((it, idx) => (
      <React.Fragment key={idx}>
        {formatItemFragment(it.name, it.quantity, it.value_min, it.value_max)}
        {idx < items.length - 1 && " + "}
      </React.Fragment>
    ));
  }
  if (typeof items === "string") return items || "none";
  return "none";
}

const RecentTradesList = ({ trades }) => {    
  if (!trades || trades.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" align="center">
        No recent trades found.
      </Typography>
    );
  }

  return (
    <Stack spacing={2} sx={{ width: "100%", maxWidth: 800 }}>
      {trades.map((trade) => (
        <Paper key={trade.tradeId} sx={{ p: 2, borderRadius: 2, boxShadow: 2, textAlign: "left", width: "100%" }}>
          {/* Header: username */}
          <Typography variant="h6" color="secondary">
            {trade.user?.username || "Unknown user"}
          </Typography>

          {/* Subheader: user id / discord / trade id */}
          <Typography variant="body2" color="text.secondary">
            trade id: {trade.tradeId} | user id: {trade.user?.id ?? "-"}
            {trade.user?.discord_id ? ` | Discord: ${trade.user.discord_id}` : ""}
          </Typography>

          {/* Trade date */}
          <Typography variant="body2" sx={{ mt: 1 }}>
            <strong>Date:</strong> {trade.tradeDate || "-"}
          </Typography>

          <Divider sx={{ my: 1 }} />

          {/* Items */}
          <Typography variant="body2">
            <strong>Items Sent:</strong> {renderItems(trade.itemsSent)}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            <strong>Items Received:</strong> {renderItems(trade.itemsReceived)}
          </Typography>

          {/* Notes */}
          <Typography variant="body2" sx={{ mt: 1 }}>
            <strong>Notes:</strong> {trade.notes || "none"}
          </Typography>
        </Paper>
      ))}
    </Stack>
  );
};

export default RecentTradesList;